import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "access-denied" }
const _hoisted_2 = { class: "access-denied__card" }
const _hoisted_3 = { class: "access-denied__content" }
const _hoisted_4 = { class: "access-denied__title" }
const _hoisted_5 = { class: "access-denied__message" }

import { onMounted, nextTick } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import HeaderTop from "@/components/HeaderTop.vue";
import habService from "@/services/habService";
import KeycloakService from "@/services/keycloakService";
import { UseStoreUser } from "@/store/userStore";
import { hasHubRoleFromPayload, parseAccessTokenPayload } from "@/utils/token";
import type { AccessTokenPayload } from "@/utils/token";


export default /*@__PURE__*/_defineComponent({
  __name: 'AccessDenied',
  props: {
  message: {
    type: String,
    default: undefined
  }
},
  setup(__props) {

const props = __props;

const { t } = useI18n();
const router = useRouter();

const message = props.message && t(props.message) || t("accessDenied.productAccessMessage");

function userHasHubAccess(): boolean {
  const userStore = UseStoreUser();
  if (userStore.hasAnyHubRole) {
    return true;
  }
  const tokenParsed = KeycloakService.currentInstance?.tokenParsed;
  if (
    tokenParsed &&
    typeof tokenParsed === "object" &&
    hasHubRoleFromPayload(tokenParsed as AccessTokenPayload)
  ) {
    return true;
  }
  const raw =
    typeof KeycloakService.token === "function"
      ? KeycloakService.token()
      : undefined;
  const decoded = raw?.trim()
    ? parseAccessTokenPayload(raw)
    : null;
  return decoded !== null && hasHubRoleFromPayload(decoded);
}

onMounted(async () => {
  habService.loadUserRolesFromToken();
  await nextTick();
  if (userHasHubAccess()) {
    await router.replace({ name: "home" });
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(HeaderTop, { "access-denied-mode": "" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h1", _hoisted_4, _toDisplayString(_unref(t)("accessDenied.title")), 1),
          _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(message)), 1)
        ])
      ])
    ])
  ], 64))
}
}

})